import invariant from 'invariant'

import {
  LOGIN,
  LOGIN_FAILURE,
  LOGOUT,
  SWITCH_ORGANIZATION,
  UNSTABLE_PREVENT_APPLICATION_FROM_RENDERING,
} from './actions'
import { SessionActionT, SessionStateT } from '../types'

const defaultState: SessionStateT = {
  sessionState: 'unknown',
}

function sessionReducer(
  state = defaultState,
  action: SessionActionT
): SessionStateT {
  switch (action.type) {
    case LOGIN: {
      const { user, token, fileDownloadSecret, organization, organizations } =
        action.payload

      if (state.sessionState === 'loggedOut') {
        const { mustLoginWithSPM, ...restOfSession } = state
        return {
          ...restOfSession,

          user,
          organization,
          organizations,
          token,
          fileDownloadSecret,
          preventApplicationRender: true,
          sessionState: 'loggedIn',
        }
      }

      return {
        ...state,

        user,
        organization,
        organizations,
        token,
        fileDownloadSecret,
        preventApplicationRender: true,
        sessionState: 'loggedIn',
      }
    }

    // Prevent application from rendering before
    // data has been written to local storage
    case UNSTABLE_PREVENT_APPLICATION_FROM_RENDERING: {
      invariant(
        state.sessionState === 'loggedIn',
        `Can only process UNSTABLE_PREVENT_APPLICATION_FROM_RENDERING on a logged in state, not "${state.sessionState}"`
      )

      return {
        ...state,
        preventApplicationRender: false,
      }
    }

    case LOGIN_FAILURE: {
      return {
        sessionState: 'loggedOut',
      }
    }

    case LOGOUT: {
      if (action.payload) {
        return {
          sessionState: 'loggedOut',
          mustLoginWithSPM: action.payload.mustLoginWithSPM,
        }
      }

      return {
        sessionState: 'loggedOut',
      }
    }

    case SWITCH_ORGANIZATION: {
      const { newOrganization } = action.payload

      invariant(
        state.sessionState === 'loggedIn',
        `Can only process SWITCH_ORGANIZATION on a logged in state, not "${state.sessionState}"`
      )

      return {
        ...state,
        organization: newOrganization,
      }
    }

    default: {
      return state
    }
  }
}

export default sessionReducer
